module.exports = __webpack_public_path__ + "static/media/search_user_active.e33fef84.svg";